import { faClone } from '@fortawesome/free-regular-svg-icons'
import { faChalkboardTeacher, faReply, faUsers } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './ForumCategoryHeader.module.css'
const ForumCategoryHeader = ({data}) => {
    return (
        <div className={Style.HeaderComponent}>
            <div className={Style.InfoCourse}>
                <p><FontAwesomeIcon icon={faChalkboardTeacher}/> نام دوره: <span style={{color:'#F477FE'}}>{data.name}</span></p>
                <p><FontAwesomeIcon icon={faClone}/> تعداد سوالات مطرح شده:<span style={{color:'#F477FE'}}>{data.total_question}</span></p>
            </div>
            <div className={Style.InfoCourse}>
            <p><FontAwesomeIcon icon={faReply}/> تعداد پاسخ ها : <span style={{color:'#77FE92'}}>{data.total_answer}</span></p>
                <p><FontAwesomeIcon icon={faUsers}/> اعضا انجمن : <span style={{color:'#77FE92'}}>{data.total_user}</span></p>
            </div>
        </div>
    )
}

export default ForumCategoryHeader
